// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Card,
    CardContent,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
    IconButton,
    Tab,
    Tooltip,
} from '@mui/material'

import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang, getProses } from '../../../../api/helper';
import { useToast } from '../../../../components/ToastProvider';
import moment from 'moment';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import Swal from 'sweetalert2';
import { TabContext, TabList, TabPanel } from '@mui/lab';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();
    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    // Ambil value tab dari query param
    const [searchParams] = useSearchParams();
    const currentView = searchParams.get('view') || '0';
    const [search, setSearch] = useState('')


    const [tabs, setTabs] = useState<string>(currentView)
    const [idD, setIdD] = useState<any>(null)
    const [listData, setListData] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    interface FormInputs {
        subgudang: any,
        pic: any,
        keterangan: any,
        tgl: any,
        link: any,

        qty_stock: any
        qty_opname: any
        qty_doc: any
        keterangan_detail: string
    }

    const defaultValues = {
    }

    const {
        control,
        watch,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/gudang/stock-opname/detail-opname/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    const master = data.master[0]
                    setValue('subgudang', master.gudang)
                    setValue('pic', master.pic)
                    setValue('keterangan', master.keterangan)
                    setValue('tgl', master.tgl)

                    const detail = response.data.detail.map((item: any) => ({
                        ...item,
                        id: String(item.id),
                        is_opname: item.keterangan ? 1 : 0
                    }));
                    setListData(detail)

                    Swal.close()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    useEffect(() => {
        getDetail();
    }, [])

    const getBarang = (rows: any) => {
        setLoading(true)
        const url = apiUrl.apiUrl + '/gudang/stock-opname/detail-barang/' + rows.id_barang
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setValue('link', data.link)
                    setValue('qty_stock', rows.qty_system)
                    setValue('qty_opname', rows.qty_opname)
                    setValue('keterangan_detail', `Opname Oleh ${getValues('pic')} pada ${moment().format('LL')}`)
                    setIdD(rows.id)
                    setLoading(false)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleClick = (e: any) => {
        const selectedData = e.data;
        getBarang(selectedData)

        setOpenDialog(true)
    };

    const handleClickCard = (e: any) => {
        getBarang(e)

        setOpenDialog(true)
    };


    const ActionButtons = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Cetak Label">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation(); // ✅ cegah rowClick
                            window.open(
                                `${apiUrl.baseUrl}/mm/barang/cetak-label/${row.id_barang}`,
                                '_blank'
                            );
                        }}
                    >
                        <Icon icon={"mdi:qrcode"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                />
            ),
        },
    ];


    // tambahkan ini di dalam komponen
    const qtyStock = watch("qty_stock");
    const qtyOpname = watch("qty_opname");

    useEffect(() => {
        if (qtyStock !== undefined && qtyOpname !== undefined) {
            const stock = parseFloat(qtyStock) || 0;
            const opname = parseFloat(qtyOpname) || 0;
            const adjustment = stock - opname;
            setValue("qty_doc", adjustment, { shouldValidate: true });
        }
    }, [qtyStock, qtyOpname, setValue]);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: string) => {
        navigate(`?view=${newValue}`);
        setTabs(newValue);
    };

    const filteredData = listData.filter((item: any) => {
        const keyword = search.toLowerCase()

        return (
            item.sku?.toLowerCase().includes(keyword) ||
            item.nama_barang?.toLowerCase().includes(keyword) ||
            item.barcode?.toLowerCase().includes(keyword)
        )
    })


    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Opname
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        Tanggal : <b>{moment(getValues('tgl')).format('LL')}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <Grid container spacing={3} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='subgudang'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='Sub Gudang'
                                            onChange={onChange}
                                            error={Boolean(errors.subgudang)}
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                                {errors.subgudang && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Subgudang harus diisi</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='pic'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='PIC'
                                            onChange={onChange}
                                            error={Boolean(errors.pic)}
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                                {errors.pic && (
                                    <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='keterangan'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='Keterangan'
                                            onChange={onChange}
                                            multiline
                                            rows={4}
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            {/* Header + Tombol di kanan */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mb: 1
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Icon icon="mdi:sync" />}
                                    onClick={() => {
                                        Swal.fire({
                                            title: 'Konfirmasi',
                                            text: 'Apakah Anda yakin ingin melakukan resingkron barang?',
                                            icon: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ya, Resingkron',
                                            cancelButtonText: 'Batal',
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                setLoading(true)
                                                const url = apiUrl.apiUrl + '/gudang/stock-opname/resingkron-barang-opname/' + id
                                                axios
                                                    .get(url, {
                                                        params: {},
                                                        headers: { Authorization: `Bearer ${token}` }
                                                    })
                                                    .then(response => {
                                                        if (response.data.success) {
                                                            getDetail()
                                                            showToast(response.data.message, 'success');
                                                            setLoading(false)
                                                        } else {
                                                            showToast(response.data.message, 'error');
                                                            setLoading(false)
                                                        }
                                                    })
                                            }
                                        })
                                    }}
                                >
                                    Resingkron Barang
                                </Button>
                            </Box>
                            <TabContext value={tabs}>
                                <TabList
                                    scrollButtons
                                    variant='fullWidth'
                                    onChange={handleChangeTabs}
                                    aria-label='forced scroll tabs example'
                                >
                                    <Tab value='0' label='DESKTOP VIEW' icon={<Icon icon='mdi:monitor' />} />
                                    <Tab value='1' label='MOBILE VIEW' icon={<Icon icon='mdi:cellphone' />} />
                                </TabList>
                                <TabPanel value='0'>
                                    <MsiDatagrid array={listData} hiddenColumns={[
                                        'id', 'mmgudang_sub_opname_id', 'id_barang', 'mmgudang_sub_id',
                                        'mmsatuan_id', 'mmsatuan_doc_id', 'created_at', 'qty_system'
                                    ]}
                                        rowStyleRules={[
                                            { field: 'is_opname', operator: '==', value: 0, color: '#FFF59D' },
                                            { field: 'is_opname', operator: '==', value: 1, color: '#A5D6A7' },
                                        ]}
                                        rowClick={handleClick}
                                        actions={actionData}
                                    />
                                </TabPanel>
                                <TabPanel value='1'>
                                    <Box sx={{ mb: 2 }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Search SKU / Nama / Barcode..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </Box>

                                    <Box>
                                        {filteredData.map((item: any) => {
                                            const borderColor =
                                                item.is_opname === 1 ? '#4caf50' : '#ffc107'

                                            return (
                                                <Card
                                                    key={item.id}
                                                    sx={{
                                                        mb: 2,
                                                        borderLeft: `6px solid ${borderColor}`,
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleClickCard(item)}
                                                >
                                                    <CardContent sx={{ pb: '12px !important' }}>
                                                        {/* Header */}
                                                        <Box display="flex" justifyContent="space-between">
                                                            <Typography fontWeight={600}>
                                                                {item.sku}
                                                            </Typography>

                                                            <IconButton size="small" onClick={() => {
                                                                window.open(
                                                                    `${apiUrl.baseUrl}/mm/barang/cetak-label/${item.id_barang}`,
                                                                    '_blank'
                                                                );
                                                            }
                                                            }>
                                                                <Icon icon="mdi:barcode" />
                                                            </IconButton>
                                                        </Box>

                                                        {/* Nama Barang */}
                                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                                            {item.nama_barang}
                                                        </Typography>

                                                        {/* Info Grid */}
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                <Typography variant="caption">
                                                                    Jenis: {item.jenis_barang}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Typography variant="caption">
                                                                    Satuan: {item.satuan}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>

                                                        <Box mt={1}>
                                                            <Typography variant="caption" display="block">
                                                                Qty Opname: {item.qty_opname}
                                                            </Typography>

                                                            <Typography variant="caption" display="block">
                                                                Qty Adjustment: {item.qty_adjustment}
                                                            </Typography>

                                                            {item.keterangan && (
                                                                <Typography variant="caption" display="block">
                                                                    Ket: {item.keterangan}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            )
                                        })}

                                        {filteredData.length === 0 && (
                                            <Typography textAlign="center" mt={4}>
                                                Data tidak ditemukan
                                            </Typography>
                                        )}
                                    </Box>
                                </TabPanel>

                            </TabContext>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialog(false)
                    let url = apiUrl.apiUrl + '/gudang/stock-opname/update-detail-opname/' + idD;
                    axios.post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setListData(prev =>
                                    prev.map(item =>
                                        item.id === idD
                                            ? {
                                                ...item,
                                                qty_opname: getValues('qty_opname'),
                                                qty_adjustment: getValues('qty_doc'),
                                                keterangan: getValues('keterangan_detail'),
                                                is_opname: 1
                                            }
                                            : item
                                    )
                                )
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                            Opname Barang
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={3}>
                            {/* <Grid item xs={12} sm={12}>
                                 {loading ? (
                                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                                        <CircularProgress disableShrink sx={{ height: '100%' }} />
                                    </Grid>
                                ) : (
                                    <Controller
                                        name="link"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                {value ? (
                                                    <Box
                                                        component="img"
                                                        src={value}
                                                        alt="Gambar Barang"
                                                        sx={{
                                                            width: '100%',
                                                            maxHeight: 150,
                                                            objectFit: 'contain',
                                                        }}
                                                    />
                                                ) : (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: 'text.secondary',
                                                            fontStyle: 'italic',
                                                            mt: 2,
                                                        }}
                                                    >
                                                        Tidak ada gambar
                                                    </Typography>
                                                )}
                                            </>
                                        )}
                                    />
                                )}
                            </Grid> */}
                            {/* QTY SYSTEM */}
                            {/* <Grid item xs={12} sm={6} hidden>
                                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 4 }}>
                                    Quantity System / Stock
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_stock"
                                        control={control}
                                        // rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity System / Stock"
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                disabled
                                            />
                                        )}
                                    />
                                    {errors.qty_stock && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid> */}

                            {/* QTY ADJUSTMENT */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_doc"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity Adjustment"
                                                type="number"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_doc && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* QTY OPNAME */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_opname"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Quantity Opname"
                                                name="qty_opname"
                                                value={
                                                    value !== undefined && value !== null && value !== ""
                                                        ? (() => {
                                                            // Format value for display: replace dot with comma, add thousand separator
                                                            const str = String(value).replace(".", ",");
                                                            const [integer, decimal] = str.split(",");
                                                            let formatted = integer
                                                                ? Number(integer).toLocaleString("id-ID")
                                                                : "";
                                                            if (decimal !== undefined) {
                                                                formatted += "," + decimal;
                                                            }
                                                            return formatted;
                                                        })()
                                                        : ""
                                                }
                                                onChange={(e) => {
                                                    let input = e.target.value;

                                                    // Remove all except digits and comma
                                                    input = input.replace(/[^0-9,]/g, "");

                                                    // Split integer and decimal part
                                                    const [intPart, decimalPart] = input.split(",");

                                                    // Format integer part with thousand separator
                                                    let formatted = "";
                                                    if (intPart) {
                                                        const parsed = parseInt(intPart, 10);
                                                        formatted = isNaN(parsed)
                                                            ? ""
                                                            : parsed.toLocaleString("id-ID");
                                                    }
                                                    if (decimalPart !== undefined) {
                                                        formatted += "," + decimalPart;
                                                    }

                                                    // Raw value for backend: replace comma with dot
                                                    const rawValue =
                                                        decimalPart !== undefined
                                                            ? `${intPart}.${decimalPart}`
                                                            : intPart;

                                                    setValue("qty_opname", rawValue);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ inputMode: "decimal" }}
                                            />
                                        )}
                                    />
                                    {errors.qty_opname && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* KETERANGAN */}
                            <Grid item xs={12} sm={6} hidden>
                                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 4 }}>
                                    Keterangan Opname
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name="keterangan_detail"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                // inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Keterangan Opname"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_detail && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}
